import { useGetRolePermissionsQuery } from '../api/rolePermissions';
import { usePreviewRole } from '../components/RoleSwitcher';

import { useFeature } from './useFeature';

import type { RolePermissionsResponse } from '../api/rolePermissions';
import type { PreviewRole } from '../components/RoleSwitcher';

// The API already drops ISO profit for roles that may not see it. This mirrors that in the
// UI and, with the demo role switcher on, previews the chosen role (it can only hide more).
export const isoProfitVisible = (
	data: RolePermissionsResponse | undefined,
	previewRole: PreviewRole | null,
): boolean =>
	!data ||
	(data.can_see_iso_profit &&
		(previewRole === null ||
			data.permissions.see_iso_profit.includes(previewRole)));

export const useIsoProfitAccess = (): { canSeeIsoProfit: boolean } => {
	const rolesOn = useFeature('roles');
	const switcherOn = useFeature('role_switcher');
	const previewRole = usePreviewRole();
	const { data } = useGetRolePermissionsQuery(undefined, { skip: !rolesOn });
	return {
		canSeeIsoProfit:
			!rolesOn || isoProfitVisible(data, switcherOn ? previewRole : null),
	};
};
